export default "__VITE_ASSET__D9ycL0mL__"